
// /**
//  * Generates a visually distinct "Vehicle" style code.
//  * Excludes ambiguous characters (0, O, I, 1, L, S) to ensure 
//  * global readability on labels and screens.
//  */
export function generateHumanReadableCode(prefix?: string): string {
    // Letters that are visually distinct and unlikely to be confused
    const distinctLetters = "ABCDEFGHJKMNPRTUVWXY";

    // Numbers excluding 0, 1, and 5 (to avoid O, I, S confusion)
    const distinctNumbers = "2346789";

    const randomLetter = distinctLetters.charAt(
        Math.floor(Math.random() * distinctLetters.length)
    );

    // Generates a 3-digit number string using distinct digits
    let numberPart = "";
    for (let i = 0; i < 3; i++) {
        numberPart += distinctNumbers.charAt(
            Math.floor(Math.random() * distinctNumbers.length)
        );
    }

    return prefix ? `${prefix}-${randomLetter}${numberPart}` : `${randomLetter}-${numberPart}`;
}

// // Examples:
// console.log(generateTaskCode());         // e.g., "X-427"
// console.log(generateTaskCode("TASK"));   // e.g., "TASK-K834"